module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addTrainingModule":"Add a module"},"fr":{"addTrainingModule":"Ajouter un module"}}')
  delete Component.options._Ctor
}
